export default "__VITE_ASSET__C22KC30t__"